module.exports = __webpack_public_path__ + "img/profile-add.00fad432.svg";